<template>
  <MediaImage
    v-if="parentType"
    v-show="isVisible"
    :id
    v-bind="image"
    :responsive-style="responsiveStyle"
    :crop-alignment="cropAlignment"
    fit="scale"
    :class="aspectClass"
    class="overflow-hidden"
    image-class="h-full w-full object-cover"
  />
  <section v-else v-show="isVisible" :id class="container">
    <div :class="aspectClass" class="overflow-hidden">
      <MediaImage
        v-bind="image"
        :responsive-style="responsiveStyle"
        :crop-alignment="cropAlignment"
        fit="scale"
        class="size-full"
        image-class="h-full w-full object-cover"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphImageFragment } from '#graphql-operations'
import type { ResponsiveStyleName } from '~/helpers/responsiveStyles'
import { resolveCantoCropAlignment } from '~/helpers/canto'

defineProps<ParagraphImageFragment>()

const { parentType, options, rootBlocks, index, siblings } = defineBlokkli({
  bundle: 'image',
  globalOptions: [
    'isHero',
    'contextToggleId',
    'bkHiddenGlobally',
    'publicationChannels',
  ],
  options: {
    cropAlignment: {
      type: 'radios',
      label: 'Fokus',
      default: 'mc',
      options: {
        tl: { label: 'Oben links', description: 'Oben links' },
        tc: { label: 'Oben mitte', description: 'Oben mitte' },
        tr: { label: 'Oben rechts', description: 'Oben rechts' },
        ml: { label: 'Mitte links', description: 'Mitte links' },
        mc: { label: 'Mitte', description: 'Mitte' },
        mr: { label: 'Mitte rechts', description: 'Mitte rechts' },
        bl: { label: 'Unten links', description: 'Unten links' },
        bc: { label: 'Unten mitte', description: 'Unten mitte' },
        br: { label: 'Unten rechts', description: 'Unten rechts' },
      },
    },
  },
  editor: {
    determineVisibleOptions: function (ctx) {
      if (ctx.parentType) {
        return [
          'cropAlignment',
          'contextToggleId',
          'bkHiddenGlobally',
          'publicationChannels',
        ]
      }

      return [
        'isHero',
        'cropAlignment',
        'contextToggleId',
        'bkHiddenGlobally',
        'publicationChannels',
      ]
    },
  },
})

const cropAlignment = computed(() =>
  resolveCantoCropAlignment(options.value.cropAlignment),
)

const id = useParagraphAnchorId(index, siblings)
const { determineVisibility } = usePartyToggle()
const isVisible = determineVisibility(options, rootBlocks)

const aspectClass = computed(() => {
  // if (!parentType.value && options.value.isHero) {
  //   return 'aspect-video'
  // }
  // return 'aspect-[4/3]'
  return ''
})

const responsiveStyle = computed<ResponsiveStyleName>(() => {
  if (!parentType.value) {
    return options.value.isHero ? 'content_fullwidth' : 'content_fullwidth_4_3'
  }

  if (
    parentType.value === 'accordion' ||
    parentType.value === 'toggle_container'
  ) {
    return 'content_fullwidth_4_3'
  }

  return 'column_half'
})
</script>
